import { _createInstance } from '../base';
//实例
let instance = null;
let flag;
const createFreeze = async function(config) {
  try {
    if (!instance && !flag) {
      flag = true;
      instance = await _createInstance(`/freeze/template`, this.$store);
    }
    flag = false;
    console.log(333333333333333, instance, config);
    instance.showPanel(config);
  } catch (error) {}
};

export default createFreeze;
export { instance };



// WEBPACK FOOTER //
// src/components/dialog/freeze/index.js